import { NgModule, CUSTOM_ELEMENTS_SCHEMA, Component } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { HttpClientModule } from '@angular/common/http';

//STORAGE
import { IonicStorageModule } from '@ionic/storage-angular';
import { Drivers } from '@ionic/storage';

import { GalleryModalComponent } from '../app/component/gallery-modal/gallery-modal.component'; // Ajuste o caminho

@NgModule({
  declarations: [AppComponent, GalleryModalComponent],
  imports: [
    BrowserModule,
    IonicModule.forRoot({
      innerHTMLTemplatesEnabled: true
    }),
    IonicStorageModule.forRoot({ driverOrder: [Drivers.IndexedDB, Drivers.LocalStorage] }),
    AppRoutingModule,
    HttpClientModule
  ],
  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy }
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA], // Permite os Web Components do Ionic
  bootstrap: [AppComponent],
})
export class AppModule { }
